import { Box } from "@mui/material"


export const AdminSettings = () => {
    return(
        <Box></Box>
    )
}